module.exports = __webpack_public_path__ + "img/WZX.500c3f47.png";